import usePendoTracking from 'customHooks/usePendoTracking';
import BaseSelect from 'lib/BaseSelect';
import { createMultiSelectPlaceholder, MultiSelectOption } from 'lib/BaseSelect/MultiSelectComponents';
import { CodeNameModel } from 'components/common/types';
import { StatusesList } from '../FilterStatus/FilterStatus.types';

interface FilterMultiStatusProps {
  isDisabled?: boolean;
  statusesList: StatusesList;
  selectedValues: CodeNameModel[];
  onSelectedStatusesChange: (values: CodeNameModel[]) => void;
}

const FilterMultiStatus = ({
  statusesList,
  isDisabled = false,
  selectedValues,
  onSelectedStatusesChange,
}: FilterMultiStatusProps): React.ReactElement => {
  const { getPendoDataId } = usePendoTracking(window.location.pathname);

  return (
    <BaseSelect
      dataPendoId={getPendoDataId('Status filter')}
      dataTestId="multiple-status-select"
      name="Multiple status filter"
      options={statusesList}
      selectedValue={selectedValues}
      isMultiple
      onSelect={(_, value: CodeNameModel[]) => onSelectedStatusesChange(value)}
      closeMenuOnSelect={false}
      isSelectionVisible={false}
      isClearable
      customComponents={{
        Placeholder: createMultiSelectPlaceholder('Status', 'Select status', 'selected-statuses-chip'),
        Option: MultiSelectOption,
      }}
      withPortal={false}
      isDisabled={isDisabled}
    />
  );
};

export default FilterMultiStatus;
